import Layout from "@/components/Layout";
import HeroSection from "@/components/HeroSection";
import ADHSSection from "@/components/ADHSSection";
import TherapyMethodSection from "@/components/TherapyMethodSection";

const HomePage = () => (
  <Layout>
    <HeroSection />
    <TherapyMethodSection />
    <ADHSSection />
  </Layout>
);

export default HomePage;
